import { requestProjectJson } from '@/libs/httpRequest';
import { projectPath } from '@/Constants/api';
import { useStoreCaseConfiguration } from '@/Store/storeCaseConfiguration';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreMeta } from '@/Store/storeMeta';

export async function getProjectByUrlParams() {
    // console.log('!!!!!!!!projectId', this.storeProjectStructure.projectId);

    const projectData =  await requestProjectJson(projectPath, { id: useStoreMeta().projectId });
    // const selectedCaseId = useStoreProjectStructure().selectedCaseId;
    const selectedCaseId = useStoreMeta().lockerUUID;
    let activeConfigurationData = {};

    if (projectData) {
        useStoreProjectStructure().setProjectName(projectData.name);
        useStoreProjectStructure().setSelectedCaseId(selectedCaseId);
        const projectJSON = await JSON.parse(projectData.json); // JSON.parse(JSON.parse(projectData.json)); TODO почему-то дважды нужно парсить (а иногда не надо)

        useStoreProjectStructure().importCases(projectJSON.commonData);

        if (selectedCaseId) {
            activeConfigurationData = projectJSON.configurationData?.[selectedCaseId];
            if (!activeConfigurationData) {
                activeConfigurationData = projectJSON.configurationData?.[Object.keys(projectJSON.configurationData)?.[0]];
            }
        } else {
            activeConfigurationData = projectJSON.configurationData?.[Object.keys(projectJSON.configurationData)?.[0]];
        }

        if (activeConfigurationData) {
            useStoreCaseConfiguration().$patch({
                caseItems: [ ...activeConfigurationData.caseItems ],
                blenderName: activeConfigurationData.blenderName,
                selectedCaseModel: activeConfigurationData.selectedCaseModel,
                colorFrame: activeConfigurationData.colorFrame,
                colorFace: activeConfigurationData.colorFace,
                isCloseDoors: activeConfigurationData.isCloseDoors ?? false,
                drawerSeparators: activeConfigurationData.drawerSeparators,
                expandedDrawersPrototypeId: activeConfigurationData.expandedDrawersPrototypeId,
            });
        }

        useStoreProjectStructure().setCasesData(projectJSON.configurationData);

    }
    console.log('patched by outer project');
}
